<template>
  <div class="box11">
    <zs />
    <hidden-govern />
    <ks />
    <px />
    <fxyp />
    <xj />
    <synx />
    <whby />
    <dclzy />
  </div>
</template>

<script>
import zs from './dqyjTable/zs.vue'
import fxyp from './dqyjTable/fxyp.vue'
import ks from './dqyjTable/ks.vue'
import px from './dqyjTable/px.vue'
import xj from './dqyjTable/xj.vue'
import hiddenGovern from './dqyjTable/hiddenGovern.vue'
import synx from './dqyjTable/synx.vue'
import whby from './dqyjTable/whby.vue'
import dclzy from './dqyjTable/dclzy.vue'
export default {
  name: 'expire',
  components: {
    zs,
    fxyp,
    ks,
    px,
    xj,
    hiddenGovern,
    synx,
    whby,
    dclzy
  },
  data() {
    return {
      
    }
  }
}
</script>

<style scoped>
  .box11 {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    /* overflow: scroll; */
  }
</style>